import React, { forwardRef, useEffect, useState } from "react";
import SnTab from "@shared/components/SnTab";
import SnButton from "@shared/components/SnButton";
import { StyleSettings } from "../../../../../styles/StyleSettings";
import { Fade } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
  allRowCount: number;
}

export const SN_SYS_BAS_REG_007_POP_001 = forwardRef(
  (
    { selectedData, modalRef, allRowCount }: popupProps,
    ref: React.Ref<any>
  ) => {
    const [text, setText] = useState("");
    const [showToast, setShowToast] = useState(false);

    useEffect(() => {
      generateSql();
    }, []);

    const generateSql = () => {
      const tableName = "sys_formgridcolumn";
      const whereKeys = ["cd_menu", "cd_grid", "cd_user", "cd_column"];
      const excludeKeys = ["KeyField", "fixCheckbox", "cd_firm"];

      const escape = (val: any) => {
        if (val === null || val === undefined) return "NULL";
        if (typeof val === "number" || typeof val === "boolean")
          return `${val}`;
        return `'${String(val).replace(/'/g, "''")}'`;
      };

      const fgVisibleValue =
        selectedData.length === allRowCount ? "'Y'" : "'N'";

      const sqlList = selectedData.map((row: any) => {
        // WHERE절 cd_user는 무조건 'admin'
        const whereClause = whereKeys
          .map((key) => {
            const val = key === "cd_user" ? "admin" : row[key];
            if (val === null || val === undefined) return `${key} IS NULL`;
            return `${key} = ${escape(val)}`;
          })
          .join(" AND ");

        // 제외할 필드 제거
        const baseKeys = Object.keys(row).filter(
          (key) => !excludeKeys.includes(key)
        );

        const columns: string[] = [];
        const values: string[] = [];

        baseKeys.forEach((key) => {
          if (key === "cd_user") {
            columns.push("cd_user");
            values.push(`'admin'`);
          } else if (key === "fg_visible") {
            columns.push("fg_visible");
            values.push(fgVisibleValue);
          } else {
            columns.push(key);
            values.push(escape(row[key]));
          }
        });

        return `
IF NOT EXISTS (
  SELECT 1 FROM ${tableName}
  WHERE ${whereClause}
) THEN
  INSERT INTO ${tableName} (cd_firm, ${columns.join(", ")})
  VALUES ('0000', ${values.join(", ")});
END IF;

INSERT INTO ${tableName} (cd_firm, ${columns.join(", ")})
SELECT mf.cd_firm, ${values.join(", ")}
FROM mas_firm mf
WHERE NOT EXISTS (SELECT 1 FROM ${tableName} f WHERE mf.cd_firm = f.cd_firm AND ${whereClause});

IF EXISTS (
  SELECT 1 FROM ${tableName}
  WHERE ${whereClause}
) THEN
  UPDATE ${tableName}
  SET
  WHERE ${whereClause};
END IF;
`.trim();
      });

      setText(sqlList.join("\n\n"));
    };

    const copyAll = () => {
      navigator.clipboard.writeText(text).then(() => {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 1000);
      });
    };

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <SnTab
            titles={["Insert"]}
            width={"100%"}
            header={[<SnButton text={"전체복사"} onClick={() => copyAll()} />]}
            body={[
              <div
                style={{
                  height: "100%",
                  border: "1px solid rgb(186,191,199)",
                  overflow: "auto",
                  fontSize: StyleSettings.font,
                  borderRadius: "4px",
                  padding: "8px",
                  whiteSpace: "pre-wrap",
                }}
              >
                {text}
              </div>,
            ]}
          />
          <Fade in={showToast} timeout={{ enter: 200, exit: 300 }}>
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1300,
              }}
            >
              <MuiAlert
                severity="success"
                variant="outlined"
                sx={{
                  backgroundColor: "#f5f5f5",
                  // color: "#656565",
                  color: "black",
                  borderColor: "#ccc",
                  fontWeight: 500,
                  padding: "0px 10px",
                  "& .MuiAlert-icon": {
                    // color: "rgb(161 161 161)",
                    marginRight: "5px",
                  },
                }}
              >
                복사되었습니다.
              </MuiAlert>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
);
